/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo } from "react";

import { UserRoles } from "@/jenesys-types/jenesys-entities/config";

import { Tab, TabbedRoute } from "@/components/common/navigation/Tabbedroute";
import { useCompany } from "@/hooks/util/useCompany";
import { useRoles } from "@/hooks/util/useRoles";

export const ClientSettingsRoute: React.FC = () => {
  const { userCannot } = useRoles();
  const { selectedCompany } = useCompany();
  let tabs = useMemo<Array<Tab>>(
    () => [
      { to: "practise-profile", text: "Company Profile" },
      { to: "connections", text: "Connections" },
      { to: "team", text: "Team" },
      { to: "billing", text: "Timer" },
      { to: "documents", text: "Documents" },
      { to: "line-item-extraction", text: "Line Item Extraction" }
    ],
    []
  );

  if (userCannot("company.read")) {
    tabs = tabs.filter((item) => item.to !== "practise-profile");
  }

  if (userCannot("company.members.read")) {
    tabs = tabs.filter((item) => item.to !== "team");
  }

  if (userCannot("company.reports") && userCannot("company.summary")) {
    tabs = tabs.filter((item) => item.to !== "billing");
  }

  if (selectedCompany?.role === UserRoles.COMPANY_USER) {
    tabs = tabs.filter((item) => item.to !== "line-item-extraction");
  }

  return (
    <React.Fragment>
      <TabbedRoute tabs={tabs} />
    </React.Fragment>
  );
};
